import React, { Component } from "react";

import Menu from "./menu";

import "./css/america-off-balance.css";

import tour1JPG from "./images/america-off-balance/tour1.jpg";
import tour1MP4 from "./images/america-off-balance/tour1.mp4";
import tour2JPG from "./images/america-off-balance/tour2.jpg";
import tour2MP4 from "./images/america-off-balance/tour2.mp4";
import tourMobile1JPG from "./images/america-off-balance/tour-mobile-1.jpg";
import tourMobile1MP4 from "./images/america-off-balance/tour-mobile-1.mp4";
import heroIllustration from "./images/america-off-balance/balance-budget-illustration.png";
import tourWireframeJPG from "./images/america-off-balance/tour-wireframe.jpg";

import LogoSVG from "./images/america-off-balance/logo.svg";

class AmericaOffBalance extends Component {
  render() {
    return (
      <div className="aob-page">
        <Menu type="projects" />
        <div className="intro section-wrapper">
          <div className="section">
            <img src={LogoSVG} alt="America Off Balance" className="hero-logo" />
            <img src={heroIllustration} alt="" className="hero-illustration" />
          </div>
          <div className="credits">
            <p>
              Work done while employed by Hyperakt
              <br />
              Client: Hoover Institution
              <br />
              Role: Developer (Intro and Tour the Budget), contributed to early strategy and content architecture
              <br />
              Illustrations by Sébastien Thibault
            </p>
          </div>
        </div>

        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>Let's chat about the national debt</h2>
              <p>
                The nation is quickly approaching a fiscal disaster. Without major reforms, future government spending
                will far exceed future revenues. Despite this reality, few Americans seem concerned. Many are unaware of
                the problem. Others wrongly conclude that minor reforms, enacted in the distant future, will be
                sufficient.
              </p>
              <p>
                <a href="https://americaoffbalance.org" target="_blank" rel="noopener noreferrer">
                  America Off Balance
                </a>{" "}
                seeks to fill this knowledge gap, providing visitors with up-to-date facts on the future of the federal
                budget. It encourages visitors to rethink their assumptions about the federal budget and to be skeptical
                of painless budget solutions often proposed by policymakers and partisan activists.
              </p>
            </div>
            <div className="feature-image">
              <video autoPlay loop muted playsInline preload="auto" poster={tour1JPG}>
                <source src={tour1MP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
            <div className="column">
              <p>
                The introduction page design called for a long animation that tells the story of the ballooning national
                debt. In thirteen frames the mockups implied elaborate dynamic transitions between each frame —
                including morphing shapes — all driven by the page scroll position.
              </p>
              <p>
                Because there is no concept of time, most animation libraries were off the table. While experimenting it
                became obvious that the solution will resemble a small game engine more so than an animation engine.
                Because the progress is tied to scroll position — which can be flicked around — it would also be
                necessary to dynamically interpolate values across frames. I settled on react-spring to natively drive
                element animations as well as dynamic SVG components where needed. The engine turned out conceptually
                simple and performance was good enough to continue in this direction.
              </p>
              <div className="feature-image mobile">
                <video autoPlay loop muted playsInline preload="auto" poster={tourMobile1JPG}>
                  <source src={tourMobile1MP4} type="video/mp4" />
                  Your browser doesn't support HTML5 video tag.
                </video>
              </div>
              <p>
                One interesting aspect of building something so choreographed for the web is that it has to also be
                fully responsive. I found myself daydreaming about the After Effects equivalent for dynamic media. There
                is a lot of say about challenges and lessons learned here but it generally worked out in the end.
              </p>
            </div>
          </div>
        </div>

        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>Tour the Budget</h2>
              <p>
                The second project I worked on was an interactive walk through of the U.S. budget. The{" "}
                <a href="https://americaoffbalance.org/tour" target="_blank" rel="noopener noreferrer">
                  tour
                </a>{" "}
                challenges the viewer to balance the future budget by enacting popular policies to raise taxes, lower
                costs or improve the economy. The experience consists of multiple choice quizes and educational moments
                that all lead to the sobering conclusion that there is no silver bullet.
              </p>
            </div>
            <div className="feature-image">
              <video autoPlay loop muted playsInline preload="auto" poster={tour2JPG}>
                <source src={tour2MP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
            <div className="column">
              <p>
                This project presented completely different challenges than the introduction — for one the sheer scale
                is much larger.{" "}
              </p>
              <p>
                <img src={tourWireframeJPG} alt="" className="tour-wireframe" />
              </p>
              <p>
                In place of the choreographed game loop in the introduction, I made use of intersection observers to
                monitor scroll progress and trigger events for the animations.
              </p>
            </div>
          </div>
        </div>

        <div className="section-wrapper conclusion">
          <div className="section">
            <div className="column">
              <p>
                <a href="https://americaoffbalance.org" target="_blank" rel="noopener noreferrer">
                  America Off Balance
                </a>{" "}
                was a very rewarding project to work on thanks to the super talented folks at Hyperakt and the team at
                Hoover. Hyperakt went on to call it{" "}
                <a href="https://x.com/hyperakt/status/1091068680451043330">
                  "one of the most elaborate things we've ever built"
                </a>{" "}
                and I'm proud to have played a part.
              </p>
              <p>
                There are two other component to this project that I was not involved with. Make sure to check out{" "}
                <a href="https://calculator.americaoffbalance.org/" target="_blank" rel="noopener noreferrer">
                  {" "}
                  Fix the Budget
                </a>{" "}
                and{" "}
                <a href="https://budgetmatters.americaoffbalance.org/" target="_blank" rel="noopener noreferrer">
                  Budget Matters
                </a>
                .
              </p>
            </div>
            <div className="column">
              <p>
                <a href="#top" className="to-top">
                  Back to top
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AmericaOffBalance;



// WEBPACK FOOTER //
// ./src/america-off-balance.js